import { Skeleton } from "@/shared/ui";

export default function FinancePageSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <div className="radius-3xl surface-base-fill py-5 px-6">
        <Skeleton height={14} width={100} className="mb-4" />
        <div className="flex justify-between items-end mb-5">
          <Skeleton height={36} width={280} />
          <Skeleton height={24} width={50} />
        </div>
        <Skeleton height={6} className="mb-2" />
        <div className="flex justify-between">
          <div className="flex flex-col gap-1">
            <Skeleton height={12} width={60} />
            <Skeleton height={16} width={140} />
          </div>
          <div className="flex flex-col gap-1 items-end">
            <Skeleton height={12} width={80} />
            <Skeleton height={16} width={120} />
          </div>
        </div>
      </div>

      <div className="radius-3xl surface-base-fill py-5 px-6">
        <Skeleton height={20} width={220} className="mb-4" />
        <Skeleton height={280} className="radius-sm" />
      </div>

      <div className="radius-3xl surface-base-fill py-5 px-6">
        <Skeleton height={20} width={160} className="mb-4" />
        <Skeleton height={240} className="radius-sm" />
      </div>

      <div className="radius-3xl surface-base-fill py-5 px-6 flex flex-col gap-5">
        <Skeleton height={20} width={150} />
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3].map(function renderSectionSkeleton(i) {
            return (
              <div key={i} className="radius-lg border surface-base-stroke surface-base-fill p-5">
                <div className="flex items-center gap-3 mb-3">
                  <Skeleton circle width={32} height={32} />
                  <Skeleton height={18} width={150} />
                </div>
                <Skeleton height={32} width={200} className="mb-2" />
                <Skeleton height={6} className="mb-3" />
                <div className="flex justify-between">
                  <Skeleton height={14} width={120} />
                  <Skeleton height={14} width={100} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
